import React from 'react';
import styles from './RadioButton.module.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const RadioButton = ({ field: { name, value, onChange, onBlur }, id, labelText, className, ...props }) => {
  return (
    <div className={`${cx('RadioButton')} ${className}`}>
      <label className={cx('RadioButton__container')} htmlFor={id}>
        <input
          className={cx('RadioButton__container-input')}
          type="radio"
          name={name}
          id={id}
          value={id}
          checked={id === value}
          onChange={onChange}
          onBlur={onBlur}
          {...props}
        />
        <span className={cx('RadioButton__container-checkmark')}/>
        <p className={cx('RadioButton__container-label-text')}>{labelText}</p>
      </label>
    </div>
  );
};

export default RadioButton;
